import window from 'inputmask/lib/global/window';
import $ from 'jquery';

//
window.popupPopstateHandler = () => null;

$(function () {
  document.addEventListener('client_is_checked', () => {
    const clientPresent = window.client_present;
    const $cashbackFirstStepItem = $('#cashback-steps .steps-block__item-content:first');
    const $infoBlockDiscount = $('#info-block-discount');
    const $infoBlockAuth = $('#info-block-auth');

    if (!clientPresent) {
      $('.btn-reg').on('click', () => {
        // Открываем вкладку "Создать аккаунт"
        $('#auth-popup .popup-tabs__tab')[1]?.click();
      });

      return;
    }

    if ($cashbackFirstStepItem.length) {
      $cashbackFirstStepItem.children().last().remove();
      $cashbackFirstStepItem.append('<div class="steps-block__item-text">Чтобы получать кешбэк</div>');
    }

    if ($infoBlockDiscount.length) {
      const $actions = $infoBlockDiscount.find('.info-block__actions');
      $actions.empty();
      $actions.append('<div class="info-block__content">Вы уже зарегистрированы.</div>');
    }

    if ($infoBlockAuth.length) {
      $infoBlockAuth.empty();
      $infoBlockAuth.append(
        '<h4 class="info-block__title info-block__title_size_small" style="text-align: center; flex-grow: 1">' +
          'Узнайте сколько у Вас бонусов в <a href="/account/bonuses">личном кабинете →</a>' +
          '</h4>'
      );
    }
  });

  expandTargetAccordion();
});

/**
 * Раскрывает нужный аккордион, если в url был передан его id
 */
function expandTargetAccordion() {
  const hash = window.location.hash;
  if (!hash) return;

  const $targetElement = $(`${hash}.accordion`);
  if (!$targetElement.length) return;

  const $targetElementInput = $targetElement.find(`${hash}-input`);
  if (!$targetElementInput.length) return;

  $targetElementInput[0].click();
}
